import { render } from "./DataForm.vue?vue&type=template&id=1183423e"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/DataForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1183423e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1183423e', __exports__)) {
    console.log('reload')
    api.reload('1183423e', __exports__)
  }
  
  module.hot.accept("./DataForm.vue?vue&type=template&id=1183423e", () => {
    console.log('re-render')
    api.rerender('1183423e', render)
  })

}


export default __exports__